import "@popperjs/core";
import $
    from "jquery";

window.$ = window.jQuery = $;
import {
    Modal,
    Tooltip
} from "bootstrap";
import aos
    from "aos";
import "slick-carousel";
import {round} from "@popperjs/core/lib/utils/math";

$.fn.isVisible = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $(window).scrollTop();
    let viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

let utility = {
    quarterCountdown: function () {
        const now = new Date();
        let year = now.getFullYear();
        let quarterEndMonth = 3;

        // Determine the end of the current quarter
        if (now.getMonth() >= 3 && now.getMonth() < 6) {
            quarterEndMonth = 6;
        }
        else if (now.getMonth() >= 6 && now.getMonth() < 9) {
            quarterEndMonth = 9;
        }
        else if (now.getMonth() >= 9) {
            quarterEndMonth = 12;
        }

        const quarterEndDate = new Date(year, quarterEndMonth, 0); // 0 for the last day of the previous month
        const timeRemaining = quarterEndDate.getTime() - now.getTime();

        // Calculate days, hours, minutes, seconds
        const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        return {days, hours, minutes, seconds};
    },
    mobile: function () {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    },
    csrf: {
        get: function () {
            $.ajax("/actions/form/form/csrf/", {
                type: "GET",
                dataType: "JSON"
            }).done(function (Response) {
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": Response.csrf
                    },
                    cache: false
                });
                $("meta[name=\"csrf-token\"]").attr({
                    "content": Response.csrf
                });
                $("#FormCSRF").val(Response.csrf);
            });
        }
    },
    gtag: function () {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push(arguments);
    },
    scroll: function (e) {
        $("html").animate({
            scrollTop: (e.offset().top - 150)
        }, "slow");
    },
    viewable: function (e) {
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();
        let elemTop = $(e).offset().top;
        let elemBottom = elemTop + $(e).height();
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    },
    modal: {
        defaults: {
            closeable: false,
            icon: "fa fa-info",
            title: {
                text: "Info",
                color: "text-navy"
            },
            size: "modal-lg",
            state: "bg-white",
            resize: false,
            class: null,
            border: null,
            submitButtonClass: "btn-success",
            cancelButtonClass: "btn-secondary",
            closeButtonClass: "btn-close-dark"
        },
        loading: function (selector) {
            selector = (selector === undefined ? $("#ModalWindowBody") : selector);
            let HTML = "<div class=\"text-center\" style=\"width: 100%; margin: auto; padding: 15%;\"><i class=\"fa fa-spinner fa-pulse fa-fw fa-5x text-primary\"></i><div style=\"font-size: 36px;\">LOADING...</div></div>";
            selector.html(HTML);
        },
        open: function (options) {
            let Deferred = new $.Deferred();
            options = {
                closeable: (options.closeable !== undefined ? options.closeable : utility.modal.defaults.closeable),
                icon: (options.icon !== undefined ? options.icon : utility.modal.defaults.icon),
                title: {
                    text: (options.title.text !== undefined ? options.title.text : utility.modal.defaults.title.text),
                    color: (options.title.color !== undefined ? options.title.color : utility.modal.defaults.title.color)
                },
                size: (options.size !== undefined ? options.size : utility.modal.defaults.size),
                state: (options.state !== undefined ? options.state : utility.modal.defaults.state),
                resize: (options.resize !== undefined ? options.resize : utility.modal.defaults.resize),
                class: (options.class !== undefined ? options.class : utility.modal.defaults.class),
                border: (options.border !== undefined ? options.border : utility.modal.defaults.border),
                submitButtonClass: (options.submitButtonClass !== undefined ? options.submitButtonClass : utility.modal.defaults.submitButtonClass),
                cancelButtonClass: (options.cancelButtonClass !== undefined ? options.cancelButtonClass : utility.modal.defaults.cancelButtonClass),
                closeButtonClass: (options.closeButtonClass !== undefined ? options.closeButtonClass : utility.modal.defaults.closeButtonClass)
            };
            $.ajax("/actions/modal/modal/open/", {
                type: "GET",
                dataType: "HTML"
            }).done(function (HTML) {
                $.when($("#ModalWindowWrapper").html(HTML)).done(function () {
                    let $ModalWindowBody = $("#ModalWindowBody");
                    let $ModalWindowCloseButton = $("#ModalWindowCloseButton");
                    $("#ModalWindowDialog").addClass(options.size);
                    $("#ModalWindowIcon").addClass(options.icon).addClass(options.title.color);
                    $("#ModalWindowTitle").html(options.title.text).addClass(options.title.color);
                    $ModalWindowCloseButton.addClass(options.closeButtonClass);
                    if (options.closeable === false) {
                        $ModalWindowCloseButton.hide();
                    }
                    $("#ModalWindowHeader").addClass(options.state);
                    $("#ModalWindowHeader, #ModalWindowBody, #ModalWindowFooter").addClass(options.class);
                    $("#ModalWindowHeader, #ModalWindowFooter").addClass(options.border);
                    $("#ModalWindowSaveButton").addClass(options.submitButtonClass);
                    $("#ModalWindowCancelButton").addClass(options.cancelButtonClass);
                    let ModalWindow = document.getElementById("ModalWindow");
                    let $Modal = new Modal(ModalWindow, {
                        backdrop: "static",
                        keyboard: true,
                        focus: true
                    });
                    $Modal.show();
                    ModalWindow.addEventListener("hidden.bs.modal", function () {
                        $(this).remove();
                    });
                    if (options.resize === true) {
                        $ModalWindowBody.on("DOMSubtreeModified", function () {
                            utility.modal.resize($(this));
                        });
                    }
                    Deferred.resolve($ModalWindowBody);
                });
            });
            return Deferred.promise();
        },
        resize: function ($Element) {
            let ModalHeaderFooterHeight = $("#ModalWindowHeader").outerHeight() + $("#ModalWindowFooter").outerHeight();
            let y = Math.round(($(window).innerHeight() - ModalHeaderFooterHeight) / 1.4);
            $Element.height(y);
            return false;
        },
        scroll: function (selector, offset) {
            let Deferred = new $.Deferred();
            offset = (offset === undefined ? ($("#ModalWindowHeader").height() + 60) : 0);
            $("#ModalWindowBody").animate({
                scrollTop: (selector.offset().top - offset) + $(this).scrollTop()
            }, "slow", function () {
                Deferred.resolve(false);
            });
            return Deferred.promise();
        },
        video: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: "fa fa-video",
                title: {
                    text: $(selector).attr("data-title"),
                    color: "text-white"
                },
                state: "bg-danger",
                size: "modal-lg"
            };
            $.when(utility.modal.open(options)).done(function () {
                $.ajax("/actions/modal/modal/video/", {
                    type: "GET",
                    dataType: "HTML"
                }).done(function (HTML) {
                    $.when($("#ModalWindowBody").html(HTML)).done(function () {
                        $("#ModalVideoSource").attr("src", $(selector).attr("data-target"));
                        $("#ModalWindowSaveButton").remove();
                        Deferred.resolve(false);
                    });
                });
                return Deferred.promise();
            });
        },
        content: function (selector) {
            let Deferred = new $.Deferred();
            let options = {
                icon: "fa",
                title: {
                    text: null,
                    color: "text-white"
                },
                state: "bg-danger",
                size: "modal-lg",
                closeable: true
            };
            let url = $(selector).prop("href");
            $.when(utility.modal.open(options)).done(function () {
                $("#ModalWindowSaveButton, #ModalWindowIcon").remove();
                $("#ModalWindowBody").load(url, function (HTML) {
                    $.when($("#ModalWindowBody").html(HTML)).done(function () {
                        let img = "<img src=\"" + $("#ContentIcon").val() + "\" style=\"height: 32px; width: auto;\" alt=\"img\"/>";
                        $("#ModalWindowTitle").html(img);
                        Deferred.resolve(false);
                    });
                }).css({
                    height: "70vh",
                    overflow: "auto"
                });
                return Deferred.promise();
            });
        }
    }
};
let macrofab = {
    init: function () {
        let $Deferred = $.Deferred();
        utility.csrf.get();
        aos.init();
        // if the user has display scaling active, scale with CSS transform
        macrofab.utm.append();
        if ($("#LiveChatInit").length > 0) {
            //macrofab.chat.init();
        }
        let $NavBarCollapse = $(".navbar-collapse");
        $NavBarCollapse.on("hide.bs.collapse", function () {
            $("#NavTop").addClass("bg-opacity-80");
        });
        $NavBarCollapse.on("show.bs.collapse", function () {
            $("#NavTop").removeClass("bg-opacity-80");
        });
        let tooltipTriggerList = [].slice.call(document.querySelectorAll("[title*=\".\"]"));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });
        if ($("#HeroVideo").length > 0) {
            document.getElementById("HeroVideo").play();
        }
        let c = macrofab.cookie.get("HideAlert");
        let $SiteAlert = $("#SiteAlert");
        let $HeroTop = $(".hero-default");
        if ($SiteAlert.length > 0 && c !== "true") {
            $SiteAlert.addClass("d-xl-block");
            $HeroTop.addClass("alert-top");
        }
        $(".alert-dismiss").on("click", function () {
            $HeroTop.removeClass("alert-top");
            document.cookie = "HideAlert=true;path=/";
        });
        $(".link-chat").on("click", function (e) {
            e.preventDefault();
            return macrofab.chat.maximize(this);
        });
        $("form.needs-validation").each(function () {
            macrofab.form.init($(this).attr("id"));
        });
        $(document).on("click", ".btn-chat", function (e) {
            e.preventDefault();
            return macrofab.chat.maximize(this);
        });
        $(document).on("click", ".link-podcast-subscribe", function (e) {
            e.preventDefault();
            return macrofab.podcast.subscribe();
        });
        $(".icon-play").on("click", function () {
            $(".link-media").eq($(this).index(".icon-play")).trigger("click");
        });
        $(".link-media").on("click", function (e) {
            e.preventDefault();
            macrofab.media.popup(this);
        });
        $(".link-demo-video").on("click", function (e) {
            e.preventDefault();
            macrofab.demo.video();
        });
        if ($(".stat-number").length > 0) {
            macrofab.stats.init();
        }
        if ($(".webinar-tab").length > 0) {
            macrofab.webinars.init();
        }
        if ($("#PodcastEpisodePlayer").length > 0) {
            macrofab.podcast.init();
        }
        $(".member-bio").on("click", function (e) {
            e.preventDefault();
            macrofab.team.bio($(this).attr("data-value"));
        });
        if ($(".form-resource").length > 0) {
            macrofab.form.resource.init();
        }
        let $DocumentWrapper = $("#DocumentWrapper");
        if ($DocumentWrapper.length > 0 && $DocumentWrapper.attr("data-src") !== undefined) {
            macrofab.document.flipbook.init();
        }
        if ($("#reshoring-infographic").length > 0) {
            macrofab.nearshoring.init();
        }
        if ($(".card-benefit").length > 0) {
            macrofab.card.animate();
        }
        $(".btn-card-modal").on("click", function (e) {
            e.preventDefault();
            macrofab.card.text($(this).index(".btn-card-modal"));
        });
        $(".jump-to-content").on("click", function () {
            utility.scroll($("#Content").eq(0));
        });
        $("#TranscriptButton").on("click", function (e) {
            e.preventDefault();
            utility.scroll($("#TranscriptWrapper"));
        });
        $(".carousel-value-props").slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            autoplay: true,
            arrows: true,
            autoplaySpeed: 2000
        });
        $(".ns-link").hover(
            function () {
                $(this).find("p").addClass("text-blue");
                $(this).find("path").css({
                    "fill": "#000000"
                });
                $(this).find("rect").css({
                    "fill": "#ffffff"
                });
            },
            function () {
                $(this).find("p, path, rect").removeClass("text-blue");
                $(this).find("path").css({
                    "fill": "#ffffff"
                });
                $(this).find("rect").css({
                    "fill": "#000000"
                });
            });
        $("#nearshoring-definition").on("mouseover", function () {
            $(this).css({
                fill: "#70828e"
            });
        });
        if ($(".meetup-register").length > 0) {
            macrofab.meetup.init();
        }
        if ($("#ReferralForm").length > 0) {
            macrofab.referral.init();
        }
        if ($("#PlatformAccordion").length > 0) {
            $(".accordion-collapse").on("show.bs.collapse", function () {
                let i = $(this).index(".accordion-collapse");
                $.when($(".platform-gif").hide()).done(function () {
                    $(".platform-gif").eq(i).show();
                });
            });
        }
        if ($("#SwagItems").length > 0) {
            macrofab.swag.init();
        }
        if ($("#SwagCheckoutForm").length > 0) {
            macrofab.swag.checkout.init();
        }
        $(".glossary-letter").on("click", function (e) {
            e.preventDefault();
            let url = "/glossary/" + ($("#GlossaryCategoriesSelect").val().length ? $("#GlossaryCategoriesSelect").val() + "/" : "") + $(this).attr("data-letter");
            location.href = url;
        });
        $("#GlossaryCategoriesSelect").on("change", function () {
            let $GlossaryLetter = $("#GlossaryLetterSearch").val();
            let url = "/glossary/" + ($(this).val().length ? $(this).val() + "/" : "");
            if ($GlossaryLetter.length > 0) {
                url = url + $GlossaryLetter + "/";
            }
            location.href = url;
        });
        let $AnimatedGif = $(".img-animated-gif");
        let $AnimatedGifSrc = $AnimatedGif.attr("data-swap");
        if ($AnimatedGif.length > 0) {
            $(window).on("scroll load", function () {
                if (utility.viewable($AnimatedGif)) {
                    $AnimatedGif.attr("src", $AnimatedGifSrc + "?q=" + Math.random());
                }
            });
        }
        let $CountDownQuarter = $(".countdown-quarter-end");
        if ($CountDownQuarter.length > 0) {
            setInterval(function () {
                const time = utility.quarterCountdown();
                $(".countdown-days").html(time.days);
                $(".countdown-hours").html(time.hours);
                $(".countdown-minutes").html(time.minutes.toString().padStart(2, 0));
                $(".countdown-seconds").html(time.seconds.toString().padStart(2, 0));
            }, 1000);
        }
        macrofab.menu.sales.init();
        macrofab.carousel.init();
        $Deferred.resolve(false);
        return $Deferred.promise();
    },
    chat: {
        visibility: function (state) {
            switch (state.visibility) {
                case "maximized":
                    $("#HelpMenuDismiss").trigger("click");
                    break;
                case "minimized":
                    LiveChatWidget.call("hide");
                    $("#HelpMenuSales").removeClass("animate__slideOutRight").addClass("animate__slideInRight");
                    break;
                case "hidden":
                    break;
            }
            return false;
        },
        init: function () {
            window.__lc = window.__lc || {};
            window.__lc.license = 13359777;
            ;(function (n, t, c) {
                function i(n) {
                    return e._h ? e._h.apply(null, n) : e._q.push(n);
                }

                let e = {
                    _q: [],
                    _h: null,
                    _v: "2.0",
                    on: function () {
                        i(["on", c.call(arguments)]);
                    },
                    once: function () {
                        i(["once", c.call(arguments)]);
                    },
                    off: function () {
                        i(["off", c.call(arguments)]);
                    },
                    get: function () {
                        if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
                        return i(["get", c.call(arguments)]);
                    },
                    call: function () {
                        i(["call", c.call(arguments)]);
                    },
                    init: function () {
                        /* this is being called by segment */
                        /*                        let n = t.createElement("script");
                                                n.async = !0, n.type = "text/javascript", n.src = "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n)*/
                    }
                };
                !n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e;
            }
            (window, document, [].slice));

            LiveChatWidget.call("hide");
            LiveChatWidget.on("visibility_changed", macrofab.chat.visibility);
            return false;
        },
        maximize: function () {
            LiveChatWidget.call("maximize");
        },
        minimize: function () {
            LiveChatWidget.call("minimize");
        }
    },
    card: {
        position: [],
        height: [],
        ready: true,
        animate: function () {
            if (macrofab.card.ready === true) {
                $(".card-benefit").hover(
                    function () {
                        macrofab.card.ready = false;
                        let i = $(this).index(".card-benefit");
                        let $CardOverlayHeading = $(".card-overlay-heading");
                        if (typeof macrofab.card.position[i] === "undefined") {
                            macrofab.card.position[i] = $CardOverlayHeading.eq(i).css("top");
                            macrofab.card.height[i] = $CardOverlayHeading.eq(i).css("height");
                        }
                        $(".card-benefit-text").eq(i).css({
                            display: "block"
                        });
                        $(".card-benefit-heading").eq(i).addClass("fw-bold");
                        $CardOverlayHeading.eq(i).animate({
                            top: 0,
                            height: "100%"
                        }, 250, function () {

                        });
                    },
                    function () {
                        let i = $(this).index(".card-benefit");
                        $(".card-benefit-text").eq(i).css({
                            display: "none"
                        });
                        $(".card-benefit-heading").eq(i).removeClass("fw-bold");
                        $(".card-overlay-heading").eq(i).animate({
                            top: macrofab.card.position[i],
                            height: macrofab.card.height[i]
                        }, 250, function () {
                            macrofab.card.ready = true;
                        });
                    }
                );
            }
        },
        text: function (i) {
            let $Deferred = $.Deferred();
            let options = {
                icon: "",
                title: {
                    text: $(".card-modal-heading").eq(i).html(),
                    color: "text-navy"
                },
                state: "bg-white",
                size: "modal-lg",
                closeButtonClass: "btn-close-navy",
                closeable: true,
                border: false
            };
            $.when(utility.modal.open(options)).done(function () {
                $("#ModalWindowFooter").remove();
                let HTML = "<div class=\"position-relative bg-white bg-opacity-75\"><div class=\"p-3 px-lg-5 pb-lg-5\">" + $(".card-modal-text").eq(i).html() + "</div></div>";
                $.when($("#ModalWindowBody").html(HTML)).done(function () {
                    $("#ModalWindowIcon").remove();
                    $("#ModalWindowHeader > .modal-title").addClass("flex-grow-1 text-center");
                    $("#ModalWindowTitle").removeClass("d-inline-block h4");
                    $("#ModalWindowBody").css({
                        "max-height": "80vh",
                        "overflow": "auto"
                    });
                    $("#ModalTextIcon > img").removeClass("img-fluid mb-4").addClass("w-100 mb-3");
                    $("#ModalWindowCancelButton").on("click", function () {
                        $("#ModalWindowCloseButton").trigger("click");
                    });
                    $Deferred.resolve(false);
                });
            });
            return $Deferred.promise();
        }
    },
    carousel: {
        defaults: {
            slides: [7, 5, 1]
        },
        init: function () {
            $(".carousel-logos").each(function () {
                console.log("slides init");
                let slides = (this.hasAttribute("data-slides") === true ? $(this).attr("data-slides").split(", ") : macrofab.carousel.defaults.slides);
                $(this).slick({
                    autoplay: true,
                    arrows: false,
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 7,
                    slidesToScroll: 1,
                    centerMode: true,
                    mobileFirst: true,
                    variableWidth: false,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: slides[0],
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 412,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 393,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 390,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 375,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 320,
                            settings: {
                                slidesToShow: slides[2],
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            });
        }
    },
    cookie: {
        get: function (name) {
            let cookie = {};
            document.cookie.split(";").forEach(function (el) {
                let [k, v] = el.split("=");
                cookie[k.trim()] = v;
            });
            return cookie[name];
        }
    },
    demo: {
        video: function () {
            let $Deferred = $.Deferred();
            $.ajax("/actions/modal/modal/demo-video/", {
                type: "GET",
                dataType: "HTML"
            }).done(function (HTML) {
                let options = {
                    icon: "fa-solid fa-video",
                    title: {
                        text: "Demo Video",
                        color: "text-white"
                    },
                    state: "bg-danger",
                    size: "modal-fullscreen",
                    closeable: true
                };
                $.when(utility.modal.open(options)).done(function () {
                    $("#ModalWindowFooter").remove();
                    $.when($("#ModalWindowBody").html(HTML)).done(function () {
                        $("#ModalWindowCancelButton").on("click", function () {
                            $("#ModalWindowCloseButton").trigger("click");
                        });
                        $Deferred.resolve(false);
                    });
                });
            });
            return $Deferred.promise();
        }
    },
    document: {
        flipbook: {
            init: function () {
                let $DocumentWrapper = $("#DocumentWrapper");
                let DocumentURL = $DocumentWrapper.attr("data-src");
                $DocumentWrapper.flipBook({
                    pdfUrl: DocumentURL,
                    responsiveViewTreshold: 480,
                    layout: 3,
                    backgroundColor: "#F3F3F3",
                    assets: {
                        preloader: "/flipbook/images/preloader.jpg",
                        overlay: "/flipbook/images/overlay.png",
                        flipMp3: "/flipbook/mp3/turnPage.mp3",
                        spinner: "/flipbook/images/spinner.gif",
                        backgroundMp3: "/flipbook/mp3/background.mp3"
                    },
                    btnSelect: {
                        enabled: false
                    },
                    btnShare: {
                        enabled: false
                    },
                    btnDownloadPages: {
                        enabled: false
                    }
                });
                $("#DocumentTitleWrapper").show();
                return false;
            }
        }
    },
    media: {
        popup: function (element) {
            let $Deferred = $.Deferred();
            let type = "image";
            let media = $(element).find("img");
            if (media.length === 0) {
                type = "video";
                media = $(element);
            }
            if (media.length > 0) {
                let options = {
                    icon: "fa-solid " + (type === "image" ? "fa-image" : "fa-video"),
                    title: {
                        text: $(media).attr("alt"),
                        color: "text-navy"
                    },
                    state: "bg-white",
                    size: (type === "image" ? "modal-xl" : "modal-xl"),
                    closeable: true
                };
                $.when(utility.modal.open(options)).done(function () {
                    let innerHTML = "<img src=\"" + $(media).attr("src") + "\" class=\"img-fluid\" alt=\"" + $(media).attr("alt") + "\"/>";
                    if (type === "video") {
                        innerHTML = "" +
                            "<video id=\"ModalVideo\" class=\"ratio ratio-16x9\" controls=\"controls\">\n" +
                            "     <source src=\"" + $(media).find("source").attr("src") + "\" type=\"video/mp4\">\n" +
                            "</video>";
                    }
                    let HTML = "<div class=\"text-center container-fluid\">" + innerHTML + "</div>";
                    $("#ModalWindowFooter").remove();
                    $.when($("#ModalWindowBody").html(HTML)).done(function () {
                        if (type === "video") {
                            document.getElementById("ModalVideo").play();
                        }
                        $("#ModalWindowCancelButton").on("click", function () {
                            $("#ModalWindowCloseButton").trigger("click");
                        });
                        $Deferred.resolve(false);
                    });
                });
            }
            else {
                $Deferred.resolve(false);
            }
            return $Deferred.promise();
        }
    },
    meetup: {
        init: function () {
            $(".meetup-register, .meetup-map").on("click", function (e) {
                e.preventDefault();
                let id = $(this).attr("data-id");
                let options = {
                    icon: "fa-duotone fa-user-plus",
                    title: {
                        text: "Meetup Registration",
                        color: "text-white"
                    },
                    state: "bg-navy",
                    size: "modal-lg",
                    closeable: true,
                    closeButtonClass: "btn-close-white"
                };
                let parameters = {
                    action: "/form/form/meetup/",
                    id: id
                };
                if ($(this).hasClass("meetup-map")) {
                    parameters.map = true;
                    options.title.text = "Meetup Map";
                    options.icon = "fa-duotone fa-location-question";
                }
                macrofab.meetup.form(options, parameters);
            });
        },
        form: function (o, p) {
            $.ajax("/", {
                dataType: "JSON",
                data: p
            }).done(function (Response) {
                $.when(utility.modal.open(o)).done(function () {
                    $("#ModalWindowFooter").remove();
                    $.when($("#ModalWindowBody").html(Response.HTML)).done(function () {
                        $("#ModalWindowBody").css({
                            "max-height": "80vh",
                            "overflow": "auto"
                        });
                        macrofab.form.init("ModalWindowForm");
                    });
                });
            });
        }
    },
    menu: {
        sales: {
            init: function () {
                $(document).on("scroll", function () {
                    $("#HelpMenuSales").css({
                        opacity: 0.3
                    });
                    clearTimeout($.data(this, "scrollTimer"));
                    $.data(this, "scrollTimer", setTimeout(function () {
                        $("#HelpMenuSales").css({
                            opacity: 1.0
                        });
                    }, 250));
                });
                let $HelpMenuSales = $("#HelpMenuSales");
                let $HelpMenuDismiss = $("#HelpMenuDismiss > i");
                let $HelpCallOptions = $("#HelpCallOptions");
                let $HelpCallOptionsLeft = $HelpCallOptions.css("right");
                $("#HelpMenuDismiss").on("click", function (e) {
                    e.preventDefault();
                    if ($HelpMenuSales.hasClass("help-menu-hidden")) {
                        $HelpMenuSales.animate({
                            right: "0"
                        }, 500, "swing", function () {
                            $HelpMenuDismiss.addClass("fa-chevron-right").removeClass("fa-chevron-left");
                        }).removeClass("help-menu-hidden");
                    }
                    else {
                        $HelpMenuSales.animate({
                            right: "-62px"
                        }, 500, "swing", function () {
                            $HelpMenuDismiss.addClass("fa-chevron-left").removeClass("fa-chevron-right");
                        }).addClass("help-menu-hidden");
                    }
                });
                $(".help-call").on("click", function (e) {
                    e.preventDefault();
                    $HelpMenuSales.animate({
                        right: "-62px"
                    }, 500, "swing", function () {
                        $HelpCallOptions.removeClass("d-none").animate({
                            right: "0"
                        }, 500, "swing", function () {
                        });
                    }).addClass("help-menu-hidden");

                });
                $("#HelpCallOptionsDismiss").on("click", function (e) {
                    e.preventDefault();
                    $HelpCallOptions.removeClass("d-none").animate({
                        right: $HelpCallOptionsLeft
                    }, 500, "swing", function () {
                        $HelpMenuSales.animate({
                            right: "0"
                        }, 500, "swing", function () {
                            $HelpMenuDismiss.addClass("fa-chevron-right").removeClass("fa-chevron-left");
                        }).removeClass("help-menu-hidden");
                    });
                });
                return false;
            }
        }
    },
    nearshoring: {
        init: function () {
            $("#world, #plane-left, #plane-right, #stat-reshored-arrow, #boat-top, #boat-bottom, #stat-evaluating-arrow, #stat-evaluating, #stat-reshored-arrow, #stat-reshored-text").css({
                "visibility": "hidden"
            }).addClass("animate__animated");
            $(window).on("scroll load", function () {
                if (utility.viewable($("#reshoring-infographic"))) {
                    $("#world").css({
                        "visibility": "visible"
                    }).addClass("animate__fadeIn");
                    $("#plane-right").css({
                        "visibility": "visible"
                    }).addClass("animate__fadeInBottomLeft animate__slower animate__delay-1s");
                    $("#plane-left").css({
                        "visibility": "visible"
                    }).addClass("animate__lightSpeedInRight animate__slower animate__delay-1s");
                    $("#boat-top").css({
                        "visibility": "visible"
                    }).addClass("animate__slideInLeft animate__slower animate__delay-2s");
                    $("#boat-bottom").css({
                        "visibility": "visible"
                    }).addClass("animate__slideInRight animate__slower animate__delay-2s");
                    $.when($("#stat-reshored-arrow, #stat-evaluating-arrow").css({
                        "visibility": "visible"
                    }).addClass("animate__slideInRight animate__delay-5s")).done(function () {
                        setTimeout(function () {
                            $("#stat-reshored-text, #stat-evaluating").css({
                                "visibility": "visible"
                            }).addClass("animate__fadeIn animate__slower animate__delay-5s");
                        }, 1500);
                    });
                }
            });
        }
    },
    form: {
        validEmail: true,
        validatePassword: false,
        bypassDomain: false,
        init: function (FormID) {
            // allow free domain emails for live webinars
            if ($("#WebinarForm").length > 0 || $("#DocumentForm").length > 0 || $('#ReferralForm').length > 0) {
                macrofab.form.bypassDomain = true;
            }
            $("#ContactEmail").on("blur", function () {
                $("#" + FormID).removeClass("was-validated");
                if (macrofab.form.bypassDomain === false) {
                    macrofab.form.email.validate();
                }
            });
            let $FileRFQ = $("#FileRFQ");
            if ($FileRFQ.length > 0) {
                $FileRFQ.on("change", function () {
                    if (this.files[0].size > 26214400) {
                        alert("Please limit the size of your upload to 25MB");
                        this.value = "";
                    }
                    else {
                        if ($("#ItarIndicator").val() === "1") {
                            if (confirm("Are the files you're uploading in need of compliance with ITAR?  Click OK to continue uploading. Click Cancel to go to the MacroFab Platform to signup and upload your RFQ.") === false) {
                                location.href = "https://factory.macrofab.com/signup";
                            }
                        }
                    }
                });
                $("#FileRFQHelp").on("click", function () {
                    let options = {
                        icon: "fa-duotone fa-question",
                        title: {
                            text: "File Uploading Help",
                            color: "text-white"
                        },
                        state: "bg-danger",
                        size: "modal-lg"
                    };
                    let HTML = $("#FileRFQHelpText").html();
                    $.when(utility.modal.open(options)).done(function () {
                        $("#ModalWindowSaveButton").remove();
                        $.when($("#ModalWindowBody").html(HTML)).done(function () {
                            $("#ModalWindowCancelButton").on("click", function () {
                                $("#ModalWindowCloseButton").trigger("click");
                            });
                        });
                    });
                });
            }
            if ($("#DocumentForm").length > 0) {
                $(".btn-download").on("click", function (e) {
                    e.preventDefault();
                    macrofab.form.submit(FormID);
                });
            }
            let form = document.getElementById(FormID);
            if ($("#" + FormID).hasClass("bypass") === false) {
                $.when(macrofab.form.recaptcha.load()).done(function () {
                    $("#" + FormID).on("submit", function (e) {
                        e.preventDefault();
                        let grv = macrofab.form.recaptcha.validate();
                        $("#" + FormID).removeClass("was-validated");
                        $.when(macrofab.form.email.validate()).done(function () {
                            if (form.checkValidity() === false || grv === false || macrofab.form.validEmail === false) {
                                e.stopPropagation();
                                if (macrofab.form.validEmail === false) {
                                    $("#ContactEmail").addClass("is-invalid").removeClass("is-valid");
                                    macrofab.form.validEmail = false;
                                }
                                else {
                                    $("#ContactEmail").removeClass("is-invalid").addClass("is-valid");
                                    macrofab.form.validEmail = true;
                                }
                                if (grv === false) {
                                    $("#GoogleRecaptcha > div").addClass("border border-danger");
                                }
                                else {
                                    $("#GoogleRecaptcha > div").removeClass("border border-danger");
                                }
                            }
                            else {
                                macrofab.form.submit(FormID);
                            }
                            form.classList.add("was-validated");
                        });
                    });
                });
                // get apollo script if rfq or contact
                if ($("#RFQForm").length > 0 || $("#ContactForm").length > 0 || $(".beers-form").length > 0 || $("#FactoryTour").length > 0 || $("#EventForm").length > 0 || $("#ModalWindowForm").length > 0) {
                    // we have to remove the search forms due to this stupid script
                    let siteSearchHTML = [];
                    $.each($(".site-search-form"), function () {
                        siteSearchHTML.push($(this).html());
                        $(this).remove();
                    });
                    $.getScript("https://assets.apollo.io/js/meetings/meetings-widget.js", function () {
                        let t = setInterval(function () {
                            if (typeof window.ApolloMeetings.initWidget === "function" && $("#ContactEmail").length > 0) {
                                clearInterval(t);
                                window.ApolloMeetings.initWidget({
                                    appId: "66c78baf4dcbd602d0d964b0",
                                    schedulingLink: "omn-rxc-v2z"
                                });
                                // put back the search forms due to this stupid script
                                for (let i = 0; i < siteSearchHTML.length; i++) {
                                    $(".site-search-form-wrapper").eq(i).html(siteSearchHTML[i]);
                                }
                            }
                        }, 100);
                    });
                }
            }
            else {
                $("#" + FormID).on("submit", function (e) {
                    e.preventDefault();
                    $("#" + FormID).removeClass("was-validated");
                    $.when(macrofab.form.email.validate()).done(function () {
                        if (form.checkValidity() === false || macrofab.form.validEmail === false) {
                            e.stopPropagation();
                            if (macrofab.form.validEmail === false) {
                                $("#ContactEmail").addClass("is-invalid").removeClass("is-valid");
                                macrofab.form.validEmail = false;
                            }
                            else {
                                $("#ContactEmail").removeClass("is-invalid").addClass("is-valid");
                                macrofab.form.validEmail = true;
                            }
                        }
                        else {
                            macrofab.form.submit(FormID);
                        }
                        form.classList.add("was-validated");
                    });
                });
            }
        },
        email: {
            validate: function () {
                let Deferred = $.Deferred();
                if (macrofab.form.bypassDomain === false) {
                    $.ajax("/actions/form/form/email-validate/", {
                        type: "POST",
                        dataType: "JSON",
                        data: {
                            Email: $("#ContactEmail").val()
                        }
                    }).done(function (Response) {
                        if (Response.Valid === false) {
                            $("#ContactEmail").addClass("is-invalid").removeClass("is-valid");
                            macrofab.form.validEmail = false;
                            Deferred.resolve(Response);
                        }
                        else {
                            $("#ContactEmail").removeClass("is-invalid").addClass("is-valid");
                            macrofab.form.validEmail = true;
                            Deferred.resolve(Response);
                        }
                    });
                }
                else {
                    $("#ContactEmail").removeClass("is-invalid").addClass("is-valid");
                    macrofab.form.validEmail = true;
                    Deferred.resolve(true);
                }
                return Deferred.promise();
            }
        },
        submit: function (FormID) {
            let Deferred = $.Deferred();
            $("#FormSubmitButton").attr("disabled", "disabled");
            $("#FormSubmittingIcon").show();
            $.ajax("/", {
                type: "POST",
                dataType: "JSON",
                cache: false,
                contentType: false,
                processData: false,
                data: new FormData($("#" + FormID)[0])
            }).done(function (Response) {
                $("#FormSubmitButton").removeAttr("disabled");
                $("#FormSubmittingIcon").hide();
                macrofab.form.conversion(Response);
                if ($("#ModalWindowForm").length > 0) {
                    $("#ModalWindowCloseButton").trigger("click");
                }
                let options = {
                    icon: "fa-solid " + (Response.Data.Valid === true ? "fa-circle-check" : "fa-triangle-exclamation"),
                    title: {
                        text: (Response.Data.Valid === true ? "Success!" : "Error!"),
                        color: "text-white"
                    },
                    state: (Response.Data.Valid === true ? "bg-success" : "bg-danger"),
                    size: "modal-lg"
                };
                $.when(utility.modal.open(options)).done(function () {
                    if (Response.Data.Asset) {
                        $.when($("#DocumentWrapper").attr({
                            "data-src": Response.Data.Asset.FileName
                        }).show()).done(function () {
                            macrofab.document.flipbook.init();
                        });
                        location.href = "/download.php?file=" + Response.Data.Asset.FileName + "&title=" + Response.Data.Asset.Title;
                    }
                    $("#ModalWindowSaveButton").remove();
                    $.when($("#ModalWindowBody").html(Response.HTML)).done(function () {
                        $("#ModalWindowCancelButton").on("click", function () {
                            $("#ModalWindowCloseButton").trigger("click");
                            if ($("#DocumentWrapper").length > 0) {
                                utility.scroll($("#DocumentWrapper"));
                            }
                            if ($("#WebinarSource").length > 0) {
                                if ($("#WebinarSource").val().length > 0) {
                                    let $WebinarWrapper = $("#WebinarWrapper");
                                    $WebinarWrapper.show();
                                    utility.scroll($WebinarWrapper);
                                }
                                else {
                                    location.href = "/webinars";
                                }
                            }
                            if ($("#SwagCheckoutForm").length > 0) {
                                macrofab.swag.cart.empty();
                                location.href = "/";
                            }
                            let $RedirectURL = $("#RedirectURL");
                            if ($RedirectURL.length && $RedirectURL.val().length > 0) {
                                location.href = $RedirectURL.val();
                            }
                        });
                        Deferred.resolve(false);
                    });
                });
            });
            return Deferred.promise();
        },
        password: {
            validate: function () {
                let valid = true;
                $("input[type=\"password\"]").each(function (i) {
                    if (i > 0 && $(this).val() !== $("input[type=\"password\"]").eq(0).val()) {
                        valid = false;
                    }
                });
                return valid;
            }
        },
        recaptcha: {
            load: function () {
                let $Deferred = $.Deferred();
                if ($("#GoogleRecaptcha").length > 0) {
                    $.getScript("https://www.google.com/recaptcha/api.js?render=explicit", function () {
                        let t = setInterval(function () {
                            if (typeof grecaptcha.render === "function") {
                                clearInterval(t);
                                grecaptcha.render("GoogleRecaptcha", {
                                    "sitekey": $("#GCKey").val()
                                });
                            }
                            $('#GoogleRecaptcha > div').css('width', 'auto');
                            $Deferred.resolve(true);
                        }, 100);
                    });
                }
                else {
                    $Deferred.resolve(true);
                }
                return $Deferred.promise();
            },
            validate: function () {
                let Response = true;
                if ($("#GoogleRecaptcha").length > 0) {
                    let r = grecaptcha.getResponse();
                    if (r.length === 0) {
                        Response = false;
                    }
                }
                return Response;
            }
        },
        conversion: function (Response) {
            if (Response.Data.Valid === true) {
                if ($("#ModalWindow").length > 0) {
                    $("#ModalWindowCloseButton").trigger("click");
                }
                let $HubSpotPageName = $("#HubSpotPageName");
                let $AnalyticsEvent = $("#AnalyticsEvent");
                let $AnalyticsCategory = $("#AnalyticsCategory");
                $("#HubSpotURL").val(window.location.href);
                $HubSpotPageName.val(document.title);
                $("#HubSpotReconversion").val(Response.Data.ConversionType);
                //Segment Conversion
                analytics.track({
                    "event": $AnalyticsEvent.val(),
                    "properties": {
                        "category": $AnalyticsCategory.val(),
                        "label": $HubSpotPageName.val()
                    }
                });
                //Google Conversion
                utility.gtag("event", $AnalyticsEvent.val(), {
                    "event_category": $AnalyticsCategory.val(),
                    "event_label": $HubSpotPageName.val()
                });
                //LinkedIn Conversion
                let $LinkedInConversionID = $("#LinkedInConversionID");
                if ($LinkedInConversionID.length > 0 && $LinkedInConversionID.val().length > 0) {
                    window.lintrk("track", {
                        conversion_id: $LinkedInConversionID.val()
                    });
                }
                //Reddit Conversion
                let redditEvent = "SignUp";
                if ($("#RFQForm").length > 0 || $("#ContactForm").length > 0 || $("#FactoryTour").length > 0) {
                    redditEvent = "Lead";
                }
                rdt("track", redditEvent);
                //StackAdapt conversion
                !function (s, a, e, v, n, t, z) {
                    if (s.saq) return;
                    n = s.saq = function () {
                        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                    };
                    if (!s._saq) s._saq = n;
                    n.push = n;
                    n.loaded = !0;
                    n.version = "1.0";
                    n.queue = [];
                    t = a.createElement(e);
                    t.async = !0;
                    t.src = v;
                    z = a.getElementsByTagName(e)[0];
                    z.parentNode.insertBefore(t, z);
                }(window, document, "script", "https://tags.srv.stackadapt.com/events.js");
                saq("ts", "Wd-folTLG8gksL2J61ZfMg", {
                    "document": $("#AssetName").val(),
                    "webinar": $("#WebinarTitle").val(),
                    "conversion": $AnalyticsEvent.val()
                });
                //Bing-Microsoft Conversion
                window.uetq = window.uetq || [];
                window.uetq.push("event", $AnalyticsEvent.val(), {
                    "event_category": $AnalyticsCategory.val(),
                    "event_label": $HubSpotPageName.val()
                });
            }
        },
        resource: {
            init: function () {
                let $formResource = $("#ResourceForm");
                let $ResourceTerm = $("#ResourceTerm");
                let $TagsToggleButton = $("#TagsToggleButton");
                let $TagsWrapper = $("#TagsWrapper");
                if (window.location.search.length > 0 && $TagsWrapper.length > 0) {
                    $TagsWrapper.collapse("show");
                    setTimeout(function () {
                        utility.scroll($("#AccordionTags"));
                    }, 2000);
                }
                $(".btn-tag-filter").on("change", function () {
                    if ($(this).val() === "all") {
                        $(".tag-all").show();
                    }
                    if ($(this).val() === "popular") {
                        $(".tag-all").hide();
                    }
                });
                $formResource.on("submit", function (e) {
                    e.preventDefault();
                    let tags = [];
                    let $ResourceTags = $("#ResourceTags");
                    let $ButtonView = $(".btn-view:checked");
                    $(".btn-tag:checked").each(function () {
                        tags.push($(this).val());
                    });
                    if (tags.length > 0) {
                        $ResourceTags.val(tags.join(","));
                    }
                    else {
                        $ResourceTags.remove();
                    }
                    let q = (tags.length > 0 ? "tags=" + tags.join(",") : "");
                    q += ($ResourceTerm.length > 0 ? (q.length > 0 ? "&" : "") + "q=" + $ResourceTerm.val() : "");
                    q += (q.length > 0 ? "&" : "") + "view=" + $ButtonView.val();
                    location.href = window.location.pathname + (q.length > 0 ? "?" + q : "");
                    return true;
                });
                $formResource.on("reset", function (e) {
                    e.preventDefault();
                    $(".btn-tag:checked").each(function () {
                        $(this).removeAttr("checked");
                    });
                    $ResourceTerm.val("");
                    location.href = window.location.pathname;
                });
            }
        }
    },
    podcast: {
        loaded: false,
        init: function () {
            $(".podcast-transcript").on("click", function (e) {
                e.preventDefault();
                let $PodcastTranscript = $("#PodcastTranscript");
                $PodcastTranscript.show("slow", function () {
                    utility.scroll($PodcastTranscript);
                });
                return false;
            });
            return false;
        },
        subscribe: function () {
            let Deferred = $.Deferred();
            $.ajax("/actions/modal/modal/podcasts/", {
                type: "GET",
                dataType: "HTML"
            }).done(function (Response) {
                let options = {
                    icon: "fa fa-podcast",
                    title: {
                        text: "Pick Your Favorite Provider",
                        color: "text-white"
                    },
                    state: "bg-danger",
                    size: "modal-lg",
                    closeButtonClass: "btn-close-white",
                    closeable: true
                };
                $.when(utility.modal.open(options)).done(function () {
                    $("#ModalWindowSaveButton").remove();
                    $.when($("#ModalWindowBody").html(Response)).done(function () {
                        $("#ModalWindowFooter").remove();
                        $("#ModalWindowCancelButton").on("click", function () {
                            $("#ModalWindowCloseButton").trigger("click");
                        });
                        analytics.track({
                            "event": "Podcast Subscribe Click",
                            "properties": {
                                "category": "Click",
                                "label": window.location.title
                            }
                        });
                        Deferred.resolve(false);
                    });
                });
            });
            return Deferred.promise();
        }
    },
    referral: {
        init: function () {
            $(document).on("click", ".btn-referral-add", function () {
                let $ReferralRow = $(".row-referral").eq(0);
                let $ReferralClone = $ReferralRow.clone(false);

                $("#ReferralInputs").append($ReferralClone);
                let $FormEmail = $('.form-email');
                let $LabelEmail = $('.label-email');
                $FormEmail.eq($FormEmail.length - 1).val('').focus().attr('id', 'ReferralEmail' + ($FormEmail.length));
                $LabelEmail.eq($LabelEmail.length - 1).attr('for', 'ReferralEmail' + ($LabelEmail.length));
                let $RemoveButton = $(".btn-referral-remove");
                if ($RemoveButton.length > 1) {
                    $RemoveButton.removeAttr("disabled");
                }
                else {
                    $RemoveButton.eq(0).attr("disabled", "disabled");
                }
                return false;
            });
            $(document).on("click", ".btn-referral-remove", function () {
                let i = $(this).index(".btn-referral-remove");
                if (i > 0) {
                    $(".row-referral").eq(i).remove();
                }
                $('.form-email').eq($('.form-email').length - 1).focus();
                let $RemoveButton = $(".btn-referral-remove");
                if ($RemoveButton.length === 1) {
                    $RemoveButton.eq(0).attr("disabled", "disabled");
                }
                else {
                    $RemoveButton.removeAttr("disabled");
                }
                return false;
            });
            $(document).on("click", "#ButtonCopy", function () {
                let shareURL = document.getElementById("ShareURL");
                shareURL.select();
                navigator.clipboard
                    .writeText(shareURL.value)
                    .then(() => {
                        $("#ShareURLCopied").show();
                    })
                    .catch(() => {
                        $("#ShareURLCopied").html("Something went wrong!").removeClass("text-success").addClass("text-danger");
                    });
            });
        }
    },
    stats: {
        duration: 25,
        init: function () {
            $(window).on("scroll load", function () {
                let statNumber = $(".stat-number");
                let statCounter = $(".stat-counter");
                let statPlus = $(".stat-plus");
                let statWrapper = $(".stat-number-wrapper");
                statNumber.each(function (i) {
                    let e = $(this);
                    let min = 0;
                    if (utility.viewable(e)) {
                        if ($(this).hasClass("no-count")) {
                            statNumber.eq(i).html($(this).attr("data-value"));
                            statCounter.eq(i).val($(this).attr("data-value"));
                            statWrapper.addClass("animate__animated animate__heartBeat");
                        }
                        else {
                            let max = parseInt($(this).attr("data-value"));
                            let step = Math.round(max / (max < macrofab.stats.duration ? 10 : macrofab.stats.duration));
                            setTimeout(function () {
                                let t = setInterval(function () {
                                    let current = parseInt(statCounter.eq(i).val());
                                    if (current < max) {
                                        statNumber.eq(i).html((current + step).toLocaleString());
                                        statCounter.eq(i).val(current + step);
                                    }
                                    if (current >= max) {
                                        clearInterval(t);
                                        statNumber.eq(i).html(max.toLocaleString());
                                        statPlus.eq(i).fadeIn();
                                        statCounter.eq(i).val(max);
                                        statWrapper.addClass("animate__animated animate__heartBeat");
                                    }
                                }, 100);
                            }, 500);
                        }
                    }
                    else {
                        statNumber.eq(i).html(min.toLocaleString());
                        statPlus.eq(i).fadeOut();
                        statCounter.eq(i).val(min);
                        statWrapper.removeClass("animate__animated animate__heartBeat");
                    }
                });
            });
        }
    },
    swag: {
        init: function () {
            // by default, don't show the cart and search for parameter to indicate that the cart can be shown
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let cartShow = 0;
            let cartRep = 0;
            document.cookie = "CartLanding=" + location.href + ";path=/";
            for (let [key, value] of params.entries()) {
                // show the cart options
                if (["cs"].indexOf(key) !== -1) {
                    cartShow = 1;
                }
                // show the MacroFab rep form
                if (["cr"].indexOf(key) !== -1) {
                    // match found
                    cartRep = 1;
                    cartShow = 1;
                }
                if (["cc"].indexOf(key) !== -1) {
                    $(".swag-cookies-clear").eq(0).trigger("click");
                }
            }
            let cartShowCookie = macrofab.cookie.get("CartShow");
            let cartRepCookie = macrofab.cookie.get("CartRep");
            // set the cookie to either show the cart or not
            if (cartShowCookie === undefined) {
                document.cookie = "CartShow=" + cartShow + ";path=/";
                if (cartShow === 1) {
                    $(".cart-show").show();
                }
            }
            else {
                if (parseInt(cartShowCookie) === 1) {
                    $(".cart-show").show();
                }
            }
            // set the cookie to either show the rep form or not during checkout
            if (cartRepCookie === undefined) {
                document.cookie = "CartRep=" + cartRep + ";path=/";
            }
            macrofab.swag.cart.update();
            $("#SwagCategoriesSelect").on("change", function () {
                let $SwagItem = $(".swag-item");
                $SwagItem.hide();
                if ($(this).val() === "") {
                    $SwagItem.fadeIn();
                }
                else {
                    $("." + $(this).val()).fadeIn();
                }
            });
            $(".swag-cart-empty").on("click", function () {
                $.when(macrofab.swag.cart.empty()).done(function () {
                    macrofab.swag.cart.update();
                });
                return false;
            });
            $(".swag-cookies-clear").on("click", function (e) {
                e.preventDefault();
                document.cookie = "Cart=;expires=" + new Date(0).toUTCString() + ";path=/";
                document.cookie = "CartRep=;expires=" + new Date(0).toUTCString() + ";path=/";
                document.cookie = "CartShow=;expires=" + new Date(0).toUTCString() + ";path=/";
                location.href = "/";
            });
            $(".link-img-swag").on("click", function (e) {
                e.preventDefault();
                let i = $(this).index(".link-img-swag");
                let $ImgElement = $(".img-swag").eq(i);
                let $SwagId = $ImgElement.attr("data-swag-id");
                $(".img-swag-default[data-swag-id=\"" + $SwagId + "\"]").attr({
                    "src": $ImgElement.attr("src"),
                    "title": $ImgElement.attr("title"),
                    "alt": $ImgElement.attr("alt")
                });
                $.when($(".img-default-label[data-swag-id=\"" + $SwagId + "\"]").html($ImgElement.attr("alt"))).done(function () {
                    $(".img-swag-default[data-swag-id=\"" + $SwagId + "\"]").trigger("click");
                });
                return false;
            });
            $(".img-swag-default").on("click", function (e) {
                e.preventDefault();
                let i = $(this).index(".img-swag-default");
                let $ImgElement = $(".img-swag-default").eq(i);
                let $ImgZoom = $ImgElement.clone().removeClass("img-swag-default card-img-top").addClass("img-zoom").css({
                    "width": "100%",
                    "height": "auto"
                }).attr({
                    "id": "SwagItemZoomImage"
                });
                let options = {
                    icon: "fa-duotone fa-aperture",
                    title: {
                        text: $ImgElement.attr("title"),
                        color: "text-white"
                    },
                    state: "bg-mf-navy",
                    size: "modal-lg",
                    closeable: true,
                    closeButtonClass: "btn-close-white"
                };
                $.when(utility.modal.open(options)).done(function () {
                    $("#ModalWindowFooter").hide();
                    $("#ModalWindowBody").html($ImgZoom).css({
                        "overflow": "auto"
                    });
                });
            });
            $(".swag-details").on("click", function (e) {
                e.preventDefault();
                macrofab.swag.details(this);
            });
            $(".swag-form").on("submit", function (e) {
                e.preventDefault();
                let formID = $(this).attr("id");
                let $FormID = $("#" + formID);
                $FormID.removeClass("was-validated");
                if (this.checkValidity() === false) {
                    e.stopPropagation();
                }
                else {
                    macrofab.swag.cart.add(formID);
                }
                $FormID.addClass("was-validated");
            });
        },
        details: function (element) {
            let i = $(element).index(".swag-details");
            let $ImgElement = $(".img-swag-default").eq(i);
            let $Image = $ImgElement.attr("src");
            let $Title = $ImgElement.attr("title");
            let $ShortDescription = $(".swag-description-short").eq(i).html();
            let $LongDescription = $(".swag-description-long").eq(i).html();
            let $HTML = "<img src=\"" + $Image + "\" alt=\"" + $Title + "\" class=\"float-start p-4 w-25 me-5\" /><p class=\"fw-bold mb-3\">" + $ShortDescription + "</p><p>" + $LongDescription + "</p></div>";
            let options = {
                icon: "fa-duotone fa-aperture",
                title: {
                    text: $Title,
                    color: "text-white"
                },
                state: "bg-mf-navy",
                size: "modal-lg",
                closeable: true,
                closeButtonClass: "btn-close-white"
            };
            $.when(utility.modal.open(options)).done(function () {
                $("#ModalWindowFooter").hide();
                $("#ModalWindowBody").html($HTML).css({
                    "overflow": "auto"
                });
            });
        },
        cart: {
            update: function () {
                let cart = macrofab.cookie.get("Cart");
                let qty = 0;
                if (cart !== undefined) {
                    let items = cart.split("|");
                    for (let i = 0; i < items.length; i++) {
                        let item = JSON.parse(items[i]);
                        qty += parseInt(item["Swag[Qty]"]);
                    }
                }
                let qtyMax = $("#SwagQtyMax").val();
                if (qty > parseInt(qtyMax)) {
                    macrofab.swag.cart.notification("Too many items selected! Please remove items your cart to maximum quantity of " + qtyMax + ".", "danger");
                }
                $(".swag-item-count").html(qty);
            },
            add: function (FormID) {
                let cart = macrofab.cookie.get("Cart");
                let item = new FormData($("#" + FormID)[0]);
                let itemJson = Object.fromEntries(item.entries());
                let s = (parseInt(itemJson["Swag[Qty]"]) > 1 ? "s" : "");
                if (cart === undefined) {
                    document.cookie = "Cart=" + JSON.stringify(itemJson) + ";path=/";
                }
                else {
                    document.cookie = "Cart=" + cart + "|" + JSON.stringify(itemJson) + ";path=/";
                }
                macrofab.swag.cart.notification(itemJson["Swag[Qty]"] + " - " + itemJson["Swag[Name]"] + " added to your cart", "success");
                macrofab.swag.cart.update();
            },
            delete: function (i) {
                let cart = macrofab.cookie.get("Cart");
                let items = cart.split("|");
                let itemsRevised = [];
                for (let x = 0; x < items.length; x++) {
                    if (x !== i) {
                        itemsRevised.push(items[x]);
                    }
                }
                if (itemsRevised.length === 0) {
                    document.cookie = "Cart=;expires=" + new Date(0).toUTCString() + ";path=/";
                }
                else {
                    document.cookie = "Cart=" + itemsRevised.join("|") + ";path=/";
                }
                macrofab.swag.checkout.init();
            },
            empty: function () {
                let Deferred = $.Deferred();
                document.cookie = "Cart=;expires=" + new Date(0).toUTCString() + ";path=/";
                macrofab.swag.cart.notification("Your cart has been emptied!", "info");
                Deferred.resolve(false);
                return Deferred.promise();
            },
            notification: function (Text, Color) {
                let alertColor = (Color !== undefined ? Color : "info");
                let $NotificationText = $("#NotificationText");
                $NotificationText.addClass("alert-" + alertColor).html(Text);
                $("#NotificationAlert").fadeIn(function () {
                    setTimeout(function () {
                        $("#NotificationAlert").fadeOut(function () {
                            $NotificationText.removeClass("alert-" + alertColor);
                        });
                    }, 2000);
                });
                return false;
            }
        },
        checkout: {
            init: function () {
                let cart = macrofab.cookie.get("Cart");
                let items = (cart !== undefined ? cart.split("|") : []);
                let Deferred = $.Deferred();
                let cartLanding = macrofab.cookie.get("CartLanding");
                $(".btn-swag-back").attr("href", cartLanding);
                $.ajax("/actions/form/form/cart/", {
                    type: "GET",
                    dataType: "JSON",
                    data: {
                        items: items
                    }
                }).done(function (Response) {
                    $.when($("#SwagItemsList").html(Response.HTML)).done(function () {
                        if (Response.Data.length > 0) {
                            let cartRep = macrofab.cookie.get("CartRep");
                            if (parseInt(cartRep) === 1) {
                                $("#SwagRep").show();
                            }
                            else {
                                $(".mf-field").removeAttr("required");
                            }
                            $("#SwagCheckoutWrapper").slideDown();
                        }
                        $(".swag-item-delete").on("click", function () {
                            let i = $(this).index(".swag-item-delete");
                            macrofab.swag.cart.delete(i);
                        });
                    });
                    Deferred.resolve(false);
                });
            }
        }
    },
    team: {
        bio: function (id) {
            let Deferred = $.Deferred();
            $.ajax("/actions/modal/modal/bio/", {
                dataType: "HTML",
                data: {
                    id: id
                }
            }).done(function (Response) {
                let options = {
                    icon: "fa fa-user",
                    title: {
                        text: "Bio",
                        color: "text-white"
                    },
                    state: "bg-danger",
                    size: "modal-lg"
                };
                $.when(utility.modal.open(options)).done(function () {
                    $("#ModalWindowSaveButton").remove();
                    $.when($("#ModalWindowBody").html(Response)).done(function () {
                        $("#ModalWindowCancelButton").on("click", function () {
                            $("#ModalWindowCloseButton").trigger("click");
                        });
                        Deferred.resolve(false);
                    });
                });
            });
            return Deferred.promise();
        }
    },
    cta: {
        mobile: function () {
            let Deferred = $.Deferred();
            $.ajax("/actions/modal/modal/platform-mobile/", {
                dataType: "JSON",
                data: {
                    referralUrl: window.location.href
                }
            }).done(function (Response) {
                let options = {
                    icon: "fa-duotone fa-mobile",
                    title: {
                        text: Response.Data.Title,
                        color: "text-white"
                    },
                    state: "bg-mf-navy",
                    size: "modal-xl",
                    closeable: true,
                    closeButtonClass: "btn-close-white"
                };
                $.when(utility.modal.open(options)).done(function () {
                    $.when($("#ModalWindowBody").html(Response.HTML)).done(function () {
                        $("#ModalWindowForm").addClass("bypass");
                        $("#ModalWindowCancelButton").html("Cancel").on("click", function () {
                            $("#ModalWindowCloseButton").trigger("click");
                        });
                        $("#ModalWindowSaveButton").attr("type", "submit").html("Send My Link");
                        macrofab.form.init("ModalWindowForm");
                        Deferred.resolve(false);
                    });
                });
            });
            return Deferred.promise();
        }
    },
    utm: {
        parameters: [],
        append: function () {
            let utmCookie = macrofab.cookie.get("UTMs");
            let utmArray = [];
            let utmString = null;
            if (typeof utmCookie === "undefined") {
                let search = window.location.search;
                let params = new URLSearchParams(search);
                // set UTM's based on window.location
                for (let [key, value] of params.entries()) {
                    if (["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "mbsy_source", "campaignid", "mbsy", "gclid"].indexOf(key) !== -1) {
                        utmArray.push(key + "=" + value);
                    }
                }
                // if no utm's match, then see if there's a referrer and if it is, see if it's a search engine
                if (utmArray.length === 0) {
                    if (document.referrer.length > 0) {
                        let source = document.referrer;
                        let referral = "referral";
                        let searchEngines = ["google", "bing", "yahoo", "yandex", "duckduckgo", "baidu", "ask.com", "naver", "ecosia", "aol", "internet archive"];
                        let r = source.split("/");
                        if (r[2] !== undefined) {
                            source = r[2];
                            let h = source.split(".");
                            for (let i = 0; i < h.length; i++) {
                                // is this a search engine?
                                if ($.inArray(h[i], searchEngines) > -1) {
                                    source = h[i];
                                    referral = "organic";
                                }
                            }
                        }
                        // set the utm based on either referral or organic search
                        utmArray.push("utm_source=" + source);
                        utmArray.push("utm_medium=" + referral);
                    }
                    else {
                        // otherwise set to direct traffic
                        utmArray.push("utm_source=direct");
                        utmArray.push("utm_medium=none");
                    }
                }
                if (utmArray.length > 0) {
                    // set the cookie
                    utmString = utmArray.join("&").replaceAll("=", ",");
                    document.cookie = "UTMs=" + utmArray.join("&").replaceAll("=", ",") + ";path=/";
                    utmString = utmString.replaceAll(",", "=");
                }
            }
            else {
                utmString = utmCookie.replaceAll(",", "=");
            }
            /* append all sub-domain links with UTM parameters */
            if (utmString !== null) {
                let uSplit = utmString.split("&");
                $.each(uSplit, function (k, v) {
                    let p = v.split("=");
                    macrofab.utm.parameters[p[0]] = p[1];
                });
                /* populate utm fields with UTM parameters */
                $("[name=\"UTM[Source]\"]").val(macrofab.utm.parameters["utm_source"]);
                $("[name=\"UTM[Medium]\"]").val(macrofab.utm.parameters["utm_medium"]);
                $("[name=\"UTM[Campaign]\"]").val(macrofab.utm.parameters["utm_campaign"]);
                $("[name=\"UTM[Content]\"]").val(macrofab.utm.parameters["utm_content"]);
                $("[name=\"UTM[ID]\"]").val(macrofab.utm.parameters["utm_id"]);
                $("[name=\"UTM[Term]\"]").val(macrofab.utm.parameters["utm_term"]);
            }
            //send clicks to factory to track
            let isMobile = utility.mobile();
            let $FactoryLink = $("a[href*=\"factory.macrofab.com\"]");
            if (utmString !== null) {
                $FactoryLink.each(function () {
                    $(this).attr("href", $(this).attr("href") + "?" + utmString);
                });
            }
            $FactoryLink.on("click", function (e) {
                if (isMobile === true && parseInt($("#AllowMobiletoPlatform").val()) === 0) {
                    e.preventDefault();
                    macrofab.cta.mobile();
                }
                else {
                    let al = $(this).attr("href").split("?");
                    let aLabel = al[0];
                    let aEvent = "Factory Click";
                    let aCategory = "Click";
                    analytics.track({
                        "event": aEvent,
                        "properties": {
                            "category": aCategory,
                            "label": aLabel
                        }
                    });
                    utility.gtag("event", aEvent, {
                        "event_category": aCategory,
                        "event_label": aLabel
                    });
                }
            });
            return false;
        }
    },
    webinars: {
        init: function () {
            if ($("#WebinarFeatured").length === 0) {
                $("#WebinarFeaturedWrapper").hide();
            }
            $("button[data-bs-toggle=\"tab\"]").on("shown.bs.tab", function (e) {
                e.target.classList.remove("opacity-50"); // newly activated tab
                e.relatedTarget.classList.add("opacity-50"); // previous active tab
            });
        }
    }
};
$(function () {
        $.when(macrofab.init()).done(function () {
            // don't run analytics in preview mode
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let uid = params.get("uid");
            let pid = params.get("pid");
            let $ReferLink = $("a[href*=\"/invite/\"]");
            $ReferLink.each(function () {
                $(this).attr("href", "/invite/" + pid + "/" + uid + "/");
            });
            for (let [key, value] of params.entries()) {
                if (["token", "x-craft-live-preview"].indexOf(key) !== -1) {
                    $("#RunAnalytics").val(0);
                }
            }
            if (parseInt($("#RunAnalytics").val()) === 1) {
                // @formatter:off
            !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="wkSu7wT3c8UCIL6wOahsPB4QBlzhmDZ9";;analytics.SNIPPET_VERSION="4.15.3";
                analytics.load("wkSu7wT3c8UCIL6wOahsPB4QBlzhmDZ9");
                analytics.page();
            }}();
            (function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-PQCFJ46');
            $.getScript('https://www.googletagmanager.com/gtag/js?id=G-XR8T8B0Z3B', function() {
                window.dataLayer = window.dataLayer || [];
                utility.gtag('js', new Date());
                utility.gtag('config', 'G-B1JW973XSX');
                utility.gtag('config', 'G-XR8T8B0Z3B');
            });

            // @formatter:on
                !function (w, d) {
                    if (!w.rdt) {
                        var p = w.rdt = function () {
                            p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
                        };
                        p.callQueue = [];
                        var t = d.createElement("script");
                        t.src = "https://www.redditstatic.com/ads/pixel.js", t.async = !0;
                        var s = d.getElementsByTagName("script")[0];
                        s.parentNode.insertBefore(t, s);
                    }
                }(window, document);
                rdt("init", "t2_fr7tmv87");
                rdt("track", "PageVisit");
                if ($("#CaseStudyContent").length > 0 || $("#BlogContent").length > 0 || $("#VideoContent").length > 0 || $("#DocumentContent").length > 0 || $("#PodcastContent").length > 0) {
                    rdt("track", "ViewContent");
                }
                // datadog snippet
                (function (h, o, u, n, d) {
                    h = h[d] = h[d] || {
                        q: [], onReady: function (c) {
                            h.q.push(c);
                        }
                    };
                    d = o.createElement(u);
                    d.async = 1;
                    d.src = n;
                    n = o.getElementsByTagName(u)[0];
                    n.parentNode.insertBefore(d, n);
                })(window, document, "script", "https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js", "DD_RUM");
                window.DD_RUM.onReady(function () {
                    window.DD_RUM.init({
                        clientToken: "pubf259dfdf14e6f60a6cec5569994f9fbf",
                        applicationId: "610be636-23cc-4cbd-9d3a-3093fd8fabbf",
                        site: "datadoghq.com",
                        service: "web-site",
                        env: $("#EnvID").val(),
                        // Specify a version number to identify the deployed version of your application in Datadog
                        // version: '1.0.0',
                        sessionSampleRate: 100,
                        sessionReplaySampleRate: 100,
                        trackUserInteractions: true,
                        trackResources: true,
                        trackLongTasks: true,
                        defaultPrivacyLevel: "mask-user-input"
                    });
                });
                // ambassador
                (function (u, n, i, v, e, r, s, a, l) {
                    u[r] = {};
                    u[r].uid = "5b4fb077-a7c8-4751-99aa-9fee926fae63";
                    u[r].m = ["getReferrerInfo", "identify", "integrationsReady", "on", "ready", "track"];
                    u[r].queue = [];
                    u[r].f = function (t) {
                        return function () {
                            var l = Array.prototype.slice.call(arguments);
                            l.unshift(t);
                            u[r].queue.push(l);
                            return u[r].queue;
                        };
                    };
                    for (var t = 0; t < u[r].m.length; t++) {
                        l = u[r].m[t];
                        u[r][l] = u[r].f(l);
                    }
                    a = n.createElement(v);
                    a.src = e + "/us-" + u[r].uid + ".js";
                    a.async = s;
                    n.getElementsByTagName(i)[0].appendChild(a);
                })(window, document, "head", "script", "https://ambassador.macrofab.com", "mbsy", true);
            }
        });
    }
);